import { useEffect, useState } from "react";
import { Box, IconButton, Link, Slide, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ComingSoonSnackbar from "./ComingSoonSnackbar";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.metaquantpro.app";

const QR_CODE_URL = `https://api.qrserver.com/v1/create-qr-code/?size=130x130&margin=0&data=${encodeURIComponent(
  PLAY_STORE_URL
)}`;

const STORAGE_KEY = "hcfinvest_app_promo_dismissed";

const AppDownloadCard = () => {
  const [open, setOpen] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setOpen(true), 1800);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  return (
    <>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 16, sm: 100 },
            right: { xs: 16, sm: 24 },
            width: { xs: 220, sm: 280 },
            backgroundColor: "#fff",
            borderRadius: "16px",
            boxShadow: "0 12px 36px rgba(23, 37, 67, 0.25)",
            border: "1px solid #eef0f5",
            zIndex: 1300,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #172543 0%, #3a5aa8 100%)",
              px: 2,
              py: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>
              Get the HC Finvest App
            </Typography>
            <IconButton
              size="small"
              onClick={handleClose}
              aria-label="Close app download promo"
              sx={{ color: "rgba(255,255,255,0.85)", p: 0.5 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ p: 2, textAlign: "center" }}>
            <Typography sx={{ fontSize: "13px", color: "#555", mb: 1.5 }}>
              Trade Forex, Metals, Crypto & more — anytime, anywhere.
            </Typography>

            <Box
              component="img"
              src={QR_CODE_URL}
              alt="Scan to download HC Finvest Android app"
              sx={{
                width: { xs: 100, sm: 130 },
                height: { xs: 100, sm: 130 },
                p: 1,
                borderRadius: "12px",
                border: "1px solid #eee",
                mx: "auto",
                display: "block",
              }}
            />
            <Typography sx={{ fontSize: "12px", color: "#888", mt: 1, mb: 1.5 }}>
              Scan to download for Android
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: "inline-block", lineHeight: 0 }}
              >
                <Box
                  component="img"
                  src="/Images/FooterImages/png-clipart-app-store-google-playy-apple-apple-text-lo.png"
                  alt="Get it on Google Play"
                  sx={{ width: "100%", height: 40, objectFit: "contain" }}
                />
              </Link>
              <Link
                component="button"
                onClick={() => setComingSoonOpen(true)}
                sx={{ display: "inline-block", lineHeight: 0 }}
              >
                <Box
                  component="img"
                  src="/Images/FooterImages/png-clipart-app-store-google-play-apple-apple-text-logoo.png"
                  alt="Download on the App Store"
                  sx={{ width: "100%", height: 40, objectFit: "contain" }}
                />
              </Link>
            </Box>
          </Box>
        </Box>
      </Slide>

      <ComingSoonSnackbar
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        message="iOS App is launching soon — stay tuned!"
      />
    </>
  );
};

export default AppDownloadCard;
